import VabCount from "zx-count";

export default VabCount;
